<form [formGroup]="formGroup" class="mt-4">
    <div class="grid">
        <div class="col-12">            
            <span class="p-input-icon-left w-full">
                <i style="margin-top:-10px">
                    <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 3H3C2.46957 3 1.96086 3.21071 1.58579 3.58579C1.21071 3.96086 1 4.46957 1 5V17C1 17.5304 1.21071 18.0391 1.58579 18.4142C1.96086 18.7893 2.46957 19 3 19H13C13.5304 19 14.0391 18.7893 14.4142 18.4142C14.7893 18.0391 15 17.5304 15 17V5C15 4.46957 14.7893 3.96086 14.4142 3.58579C14.0391 3.21071 13.5304 3 13 3H11" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M5 12H5.01M5 15H5.01M8 14L9 15L12 12M5 3C5 2.46957 5.21071 1.96086 5.58579 1.58579C5.96086 1.21071 6.46957 1 7 1H9C9.53043 1 10.0391 1.21071 10.4142 1.58579C10.7893 1.96086 11 2.46957 11 3C11 3.53043 10.7893 4.03914 10.4142 4.41421C10.0391 4.78929 9.53043 5 9 5H7C6.46957 5 5.96086 4.78929 5.58579 4.41421C5.21071 4.03914 5 3.53043 5 3Z" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </i>
                <input formControlName="nomeTarefa" type="text" pInputText class="w-full" placeholder="Nome da tarefa"/>
            </span>
        </div>
        <div class="col-6">
            <p-dropdown 
            styleClass="w-full custom-dropdown"
            formControlName="profissional" 
            [options]="profissionais" 
            optionLabel="name"
            optionValue="id" 
            appendTo="body"
            placeholder="Profissional">
            
                <ng-template let-item pTemplate="selectedItem">
                    <i class="pi pi-user custom-dropdown-icon"></i>
                    {{item?.name}}
                </ng-template>
               
            </p-dropdown>
        </div>
        <div class="col-6">
            <p-dropdown 
            styleClass="w-full custom-dropdown"
            formControlName="prazo" 
            [options]="prazos" 
            appendTo="body"
            placeholder="Prazo tarefa">
                <ng-template let-item pTemplate="selectedItem">
                    <svg class="custom-dropdown-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16 3V7M8 3V7M4 11H20M11 15H12V18M4 7C4 6.46957 4.21071 5.96086 4.58579 5.58579C4.96086 5.21071 5.46957 5 6 5H18C18.5304 5 19.0391 5.21071 19.4142 5.58579C19.7893 5.96086 20 6.46957 20 7V19C20 19.5304 19.7893 20.0391 19.4142 20.4142C19.0391 20.7893 18.5304 21 18 21H6C5.46957 21 4.96086 20.7893 4.58579 20.4142C4.21071 20.0391 4 19.5304 4 19V7Z" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        
                    {{item}}
                </ng-template>
               
            </p-dropdown>
        </div>
        <div class="col-12">            
            <span class="p-input-icon-left w-full">
                <i style="margin-top:-12px">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 8V12M12 16H12.01M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12Z" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </i>
                <input type="text" formControlName="observacao"  pInputText class="w-full" placeholder="Observação"/>
            </span>
        </div>
    </div> 
</form>     
<div class="footer">
    <button (click)="cancelar()" pButton class="p-button-outlined p-button-secondary flex justify-content-center ">
        CANCELAR
    </button>
    <button (click)="salvar()" pButton class="flex justify-content-center">
        SALVAR
    </button>
</div>